import React from "react";
import Widget from "../../../../components/Widget/Widget";
import {Grid} from "@material-ui/core";
import {Typography} from "../../../../components/Wrappers/Wrappers";

const Statistiken = ({classes, impressions, currentJob}) => {
    return (
        <Widget
            title="Statistiken"
            upperTitle
            disableWidgetMenu
            bodyClass={classes.fullHeightBody}
            className={classes.card}>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center">
                <Grid item xs={currentJob.application_type === "email" ? 4:6}>
                    <Typography color="text" colorBrightness="secondary" noWrap>
                        Webseitenaufrufe
                    </Typography>
                    <Typography color="text" size="xl">{impressions}</Typography>
                </Grid>
                {currentJob.application_type === "email" &&
                <Grid item xs={4}>
                    <>
                        <Typography color="text" colorBrightness="secondary" noWrap>
                            Bewerber
                        </Typography>
                        <Typography color="text" size="xl">{currentJob.likes}</Typography>
                    </>
                </Grid>
                }
                {currentJob.application_type === "email" &&
                <Grid item xs={4}>
                    <>
                        <Typography color="text" colorBrightness="secondary" noWrap>
                            Bewerbungsaktionen
                        </Typography>
                        <Typography color="text" size="xl">{currentJob.clickouts}</Typography>
                    </>
                </Grid>
                }
                {currentJob.application_type === "clickout" &&
                <Grid item xs={6}>
                    <>
                        <Typography color="text" colorBrightness="secondary" noWrap>
                            Interaktionen
                        </Typography>
                        <Typography color="text" size="xl">{currentJob.clickouts}</Typography>
                    </>
                </Grid>
                }

            </Grid>
        </Widget>
    )
}

export default Statistiken;